import React from 'react';
import PropTypes from 'prop-types';

const Achievment = props => {

    const { achievment, backgroundColorHeader } = props;

    return (
        <section className="my-2 my-md-3 px-3 py-2" style={{ background: backgroundColorHeader }}>
            <h2 className="mb-0 text-white player-achievment">{achievment}</h2>
        </section>
    )
}

export default Achievment;

Achievment.propTypes = {
    achievment: PropTypes.string.isRequired,
    backgroundColorHeader: PropTypes.string.isRequired
}
